import moment from 'moment';
const message = "Estimado cliente, le contactamos desde el Servicio Técnico de IFENO 🛠";

export const isOfflineMode = () => !window.navigator.onLine;
export const isOnlineMode = () => window.navigator.onLine;

export const sendWhatsapp = (task, msg = message) => {
    window.open(`https://api.whatsapp.com/send?phone=34${task.phone}&text=${encodeURIComponent(msg)}`)
}

export const pad = (n, width, z) => {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

export const renderDate = (date, withTime) => {
    const format = withTime ? 'DD/MM/YYYY HH:mm:ss' : 'DD/MM/YYYY'
    return date ? moment(date).format(format) : "";
}

export const dateRangeFilter = (filter, timestamp) => {
    if (!filter || (!filter.from && !filter.to)) return true;
    if (!timestamp) return false;
    const date = moment(timestamp);
    if (filter.from && date.isBefore(moment(filter.from).startOf('day'))) return false;
    if (filter.to && date.isAfter(moment(filter.to).endOf('day'))) return false;
    return true;
}

const TABLE_HEIGHT_REDUCTION_PX = 7; // Cambiando este valor aumenta el alto de las tablas

export const calculateHeight = (extraMargin = 0) => {
    const header = 20;
    const headerTable = 59;
    const footer = 47;
    const margin = 40;

    const total = header + headerTable + footer + margin + extraMargin + TABLE_HEIGHT_REDUCTION_PX;
    const height = window.innerHeight - total;

    // Evita alturas negativas o ridículas
    return `${Math.max(height, 200)}px`;
};

export const renderMoney = (number = 0, decimals = true) => {
    if (decimals) {
        return `${Number(number).toFixed(2)} €`
    }
    return `${number} €`
}